import { Component, computed, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { UiSelect } from '@shared/components/ui';
import { SucursalService } from '@shared/services/sucursal.service';
import { FormsModule } from '@angular/forms';
import { AppService } from '@shared/services/app.service';

@Component({
  selector: 'app-selector-sucursal',
  standalone: true,
  imports: [UiSelect, FormsModule],
  templateUrl: './selector-sucursal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './selector-sucursal.css',
})
export class SelectorSucursal {
  constructor() {
    effect(() => {
      if (this.appService.authReady()) {
        this.sucursalState.ensureSucursalesLoaded();
      }
    });
  }

  private sucursalState = inject(SucursalService);
  private appService = inject(AppService);

  opciones = computed(() =>
    this.sucursalState.sucursales().map((sucursal) => ({
      label: sucursal.nombre,
      value: sucursal.id,
    })),
  );
  sucursalActivaId = computed(() => this.sucursalState.activeSucursal()?.id ?? null);
  cargando = computed(() => this.sucursalState.loading());
  canSelect = computed(() => this.sucursalState.canSelectSucursal());

  onSucursalChange(value: string | number | null) {
    this.sucursalState.setActiveById(Number(value));
  }
}
